import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { EnvProvider } from "./context/EnvContext";
import { UserProvider } from "./context/UserContext";

import App from "./pages/App";
import "@amzn/awsui-global-styles/polaris.css";

import {
  I18nProvider,
  importMessages,
} from "@amzn/awsui-components-react/polaris/i18n";
console.log("🎯 Entry point file loaded");

const locale = document.documentElement.lang || "en";
const messages = await importMessages(locale);
document.body.classList.add("awsui-visual-refresh");
createRoot(document.querySelector("#app")!).render(
  <EnvProvider>
    <UserProvider>
      <I18nProvider locale={locale} messages={messages}>
        <HashRouter>
          <App />
        </HashRouter>
      </I18nProvider>
    </UserProvider>
  </EnvProvider>
);
